/* eslint-disable react/no-unknown-property */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable operator-assignment */
/* eslint-disable no-shadow */
import React, { useMemo, useRef } from 'react'

import { useFrame, useThree } from '@react-three/fiber'
import {
  Color,
  Mesh,
  MeshDepthMaterial,
  PlaneGeometry,
  ShaderMaterial,
  WebGLRenderTarget,
} from 'three'

import { HorizontalBlurShader } from '../helpers/Horizontal'
import { VerticalBlurShader } from '../helpers/Vertical'

let count = 0

export const ContactShadows = React.forwardRef(
  (
    {
      scale = 10,
      frames = Infinity,
      opacity = 1,
      width = 1,
      height = 1,
      blur = 1,
      far = 10,
      resolution = 512,
      smooth = true,
      color = '#000000',
      depthWrite = false,
      renderOrder,
      ...props
    },
    ref
  ) => {
    const { gl, scene } = useThree()
    const shadowCamera = useRef(null)

    width = width * (Array.isArray(scale) ? scale[0] : scale || 1)
    height = height * (Array.isArray(scale) ? scale[1] : scale || 1)

    const [
      renderTarget,
      planeGeometry,
      depthMaterial,
      blurPlane,
      horizontalBlurMaterial,
      verticalBlurMaterial,
      renderTargetBlur,
    ] = useMemo(() => {
      const renderTarget = new WebGLRenderTarget(resolution, resolution)
      const renderTargetBlur = new WebGLRenderTarget(resolution, resolution)
      renderTargetBlur.texture.generateMipmaps = renderTarget.texture.generateMipmaps = false
      const planeGeometry = new PlaneGeometry(width, height).rotateX(Math.PI / 2)
      const blurPlane = new Mesh(planeGeometry)
      const depthMaterial = new MeshDepthMaterial()
      depthMaterial.depthTest = depthMaterial.depthWrite = false

      depthMaterial.onBeforeCompile = (shader) => {
        shader.uniforms = {
          ...shader.uniforms,
          ucolor: {
            value: new Color(color),
          },
        }
        shader.fragmentShader = shader.fragmentShader.replace(
          `void main() {`, //
          `uniform vec3 ucolor;
           void main() {
          `
        )
        shader.fragmentShader = shader.fragmentShader.replace(
          'vec4( vec3( 1.0 - fragCoordZ ), opacity );',
          'vec4( ucolor, ( 1.0 - fragCoordZ ) * 1.0 );'
        )
      }

      const horizontalBlurMaterial = new ShaderMaterial(HorizontalBlurShader)
      const verticalBlurMaterial = new ShaderMaterial(VerticalBlurShader)
      verticalBlurMaterial.depthTest = horizontalBlurMaterial.depthTest = false
      return [
        renderTarget,
        planeGeometry,
        depthMaterial,
        blurPlane,
        horizontalBlurMaterial,
        verticalBlurMaterial,
        renderTargetBlur,
      ]
    }, [resolution, width, height, color])

    const blurShadows = (blur) => {
      blurPlane.visible = true
      blurPlane.material = horizontalBlurMaterial
      horizontalBlurMaterial.uniforms.tDiffuse.value = renderTarget.texture
      horizontalBlurMaterial.uniforms.h.value = (blur * 1) / 256
      gl.setRenderTarget(renderTargetBlur)
      gl.render(blurPlane, shadowCamera.current)
      blurPlane.material = verticalBlurMaterial
      verticalBlurMaterial.uniforms.tDiffuse.value = renderTargetBlur.texture
      verticalBlurMaterial.uniforms.v.value = (blur * 1) / 256
      gl.setRenderTarget(renderTarget)
      gl.render(blurPlane, shadowCamera.current)
      blurPlane.visible = false
    }

    useFrame(() => {
      if (shadowCamera.current && (frames === Infinity || count < frames)) {
        const initialBackground = scene.background
        scene.background = null
        const initialOverrideMaterial = scene.overrideMaterial
        scene.overrideMaterial = depthMaterial
        gl.setRenderTarget(renderTarget)
        gl.render(scene, shadowCamera.current)
        scene.overrideMaterial = initialOverrideMaterial
        blurShadows(blur)
        if (smooth) blurShadows(blur * 0.4)
        gl.setRenderTarget(null)
        scene.background = initialBackground
        count += 1
      }
    })

    return (
      <group rotation-x={Math.PI / 2} ref={ref} {...props}>
        <mesh renderOrder={renderOrder} geometry={planeGeometry} scale={[1, -1, 1]} rotation={[-Math.PI / 2, 0, 0]}>
          <meshBasicMaterial
            attach="material"
            map={renderTarget.texture}
            transparent
            opacity={opacity}
            depthWrite={depthWrite}
          />
        </mesh>
        <orthographicCamera ref={shadowCamera} args={[-width / 2, width / 2, height / 2, -height / 2, 0, far]} />
      </group>
    )
  }
)
